import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";

import { RootState } from "@/store/store";
import { useDispatch, useSelector } from "react-redux";
import { closeDialog } from "@/store/reducers/dialogReducer";
import DialogLoaderButton from "../loader-button/DialogLoaderButton";
import { FILTER_DIALOG } from "@/constants/dialog-constants";
import FilterSellerSelect from "../supplier-select/FilterSellerSelect";
import StatusSelect from "../status-select/StatusSelect";
import { Seller } from "@/interfaces/Seller";
import { Status } from "@/interfaces/Return";
import { setFilter } from "@/store/reducers/filterReducer";

interface FilterDialogProps {}

const FilterDialog: React.FC<FilterDialogProps> = ({}) => {
  const dispatch = useDispatch();
  const { isOpen, dialogType } = useSelector(
    (state: RootState) => state.dialog
  );
  const [selectedSeller, setSelectedSeller] = useState<Seller>({} as Seller);
  const [selectedStatus, setSelectedStatus] = useState<Status>({} as Status);
  const isOpened = isOpen && dialogType === FILTER_DIALOG;

  const handleClose = () => {
    dispatch(closeDialog());
  };

  const handleValidate = () => {
    dispatch(
      setFilter({
        filter: {
          sellerName: selectedSeller.sellerName,
          statusId: selectedStatus.id,
        },
      })
    );
    handleClose();
  };

  return (
    <Dialog open={isOpened} onOpenChange={handleClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-center sm:text-left">
            Filtrer les demandes
          </DialogTitle>
        </DialogHeader>

        <div className="grid gap-4">
          <StatusSelect
            selectedStatus={selectedStatus}
            setSelectedStatus={setSelectedStatus}
          />
          <FilterSellerSelect
            selectedSeller={selectedSeller}
            setSelectedSeller={setSelectedSeller}
          />
        </div>

        <DialogFooter className="flex-col sm:flex-row gap-2 sm:justify-end">
          <DialogLoaderButton
            name="Appliquer"
            handleSubmit={handleValidate}
            isLoading={false}
          />
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default FilterDialog;
